// 214 §1 [ADVISOR — the list's order] — ONE FORM FOR A COUNSEL, used by both paths: the Persons list's modal
// (OpposingCounselModal) and the matter's quick add (QuickAddModal, type "ocu"). The union of the two forms it
// replaces: the list's order (title + first name · last name + firm · the name check · e-mail + phone · bar · the
// address) and the quick add's Notes at the end; from a matter, §2's party ask (`parties`) stands after the name
// check, before the contact details. Each frame hands its own field builders (`F`/`T` bound to the modal form,
// `QF`/`QT` bound to the quick-add form — the same builders, from makeFieldRows), its own title and bar selects and
// its own address block — so the two frames cannot drift apart in what they ask, only in what they are bound to.
//
// Hookless and module-scope: a function returning JSX, mounted as `<OpposingCounselFields …/>` from two components
// (never declared inside a render body — scripts/lint-inline-components.js).
/* `import React`: react/react-in-jsx-scope is counted per JSX element and this is the rule's own remedy (189 §E). */
import React from "react";
import type { makeModalFields } from "../modalFields";

type Vocab = ReturnType<typeof makeModalFields>;

interface Props {
  readonly F: Vocab["F"];
  readonly T: Vocab["T"];
  readonly TitSel: React.ReactNode;
  readonly BarSel: React.ReactNode;
  readonly nameAdvisor: React.ReactNode;
  readonly address: React.ReactNode;
  /** From a matter: the opposing parties this counsel stands for, asked as a checkbox list (§2). */
  readonly parties?: React.ReactNode;
}

export default function OpposingCounselFields({ F, T, TitSel, BarSel, nameAdvisor, address, parties }: Props) {
  return (
    <>
      <div className="field-row">
        {TitSel}
        {F("First Name *", "firstName", "", 1)}
      </div>
      <div className="field-row">
        {F("Last Name *", "lastName")}
        {F("Firm", "firm")}
      </div>
      {nameAdvisor}
      {parties ?? null}
      <div className="field-row">
        {F("Email", "email")}
        {F("Phone", "phone")}
      </div>
      {BarSel}
      {address}
      {T("Notes", "notes")}
    </>
  );
}
